<!-- Alerter template -->
<template>
    <div v-if="hasMessage" class="alert alert-dismissible fade show" role="alert" v-bind:class="{'alert-danger' : messageType == 'error', 'alert-success' : messageType == 'success' }">
    <template v-if="messageType === 'error'">
      <h4 class="alert-heading">{{ $t('errors.err_something_went_wrong') }}</h4>
    </template>
    <template v-else>
    </template>
    <strong>{{ message }}</strong>
    </div>
</template>

<script>
import 'vue';
import lodashDelay from 'lodash/delay';

export default {
  name: 'Alerter',
  data: function () {
    return {
      message: '',
      messageType: ''
    };
  },
  methods: {
    showError: function (msg, autodismiss = true) {
      let self = this;
      this.message = msg;
      this.messageType = 'error';

      if (autodismiss) {
        lodashDelay(() => { self.message = ''; }, 5000);
      }
    },
    showSuccess: function (msg, autodismiss = true) {
      let self = this;
      this.message = msg;
      this.messageType = 'success';

      if (autodismiss) {
        lodashDelay(() => { self.message = ''; }, 5000);
      }
    },
    clear () {
      this.message = '';
    }
  },
  computed: {
    hasMessage: function () {
      return (this.message.length > 0);
    }
  }
};
</script>

<style lang="scss">
</style>
